import * as React from "react"

const IconArrowDown: React.FC<{ color?: string }> = (props) => {
    const { color = "#7D8592" } = props
    return (
        <svg width="22px" height="11px" viewBox="0 0 22 11" version="1.1">
            <g stroke={color} strokeWidth="2px" fill="none" strokeLinecap="butt" >
                <path d="M 1 1 L 11 10 L 21 1" />
            </g>
        </svg>
    )
}

export default IconArrowDown
